import { Dispatch, SetStateAction, useEffect } from 'react'

import { IShotlist } from '@/types/shotlist.interface'
import { ISelectedPlatform } from '@/types/uploadForm.interface'

import { refreshFormHeaderState } from '../helpers/refreshFormHeaderState'

interface IUseFileFormHeaderSyncParams {
	shotlist?: IShotlist
	selectedPlatformList: ISelectedPlatform[]
	setSelectedPlatformList: Dispatch<SetStateAction<ISelectedPlatform[]>>
}

export const useFileFormHeaderSync = ({
	shotlist,
	selectedPlatformList,
	setSelectedPlatformList
}: IUseFileFormHeaderSyncParams) => {
	const platformsKey = selectedPlatformList.map(p => p.value).join('|')

	const translationsKey = (shotlist?.translations || [])
		.map(t => `${t.language}:${t.content ? 1 : 0}`)
		.join('|')

	// This effect refreshes states for the Form Header, when user makes some changes in the Shotlist page
	// For example - transcribing, srt uploading or translating. These changes appeare in FormHeaderStatus immediately

	useEffect(() => {
		if (!shotlist || !selectedPlatformList.length) return

		setSelectedPlatformList(prev => {
			const { next, changed } = refreshFormHeaderState({ prev, shotlist })
			return changed ? next : prev
		})
	}, [
		shotlist?.original?.language,
		shotlist?.original?.content,
		translationsKey,
		platformsKey
	])
}
